import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useStartMicrosoftEmailOAuthMutation = () => {
  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<{ data: { authUrl: string } }, Error, void>({
    mutationFn: () =>
      api.post<{ authUrl: string }>('oauth/start-flow', {
        platform: 'MICROSOFT',
        functionality: 'EMAIL_SEND',
      }),
  });

  const startOAuth = async () => {
    const response = await mutateAsync();
    return response.data;
  };

  return {
    startOAuth,
    isLoading,
    isError,
  };
};
